var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section',{staticClass:"section sticky-header-section"},[_c('main-header',{ref:"header",attrs:{"is-in-content":true,"logo-hidden":_vm.hideLogo,"fixed":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }